<template>
  <div id="app">
    <div
      v-if="loading"
      class="loading"
    >
      <dv-loading>
        加载中...
      </dv-loading>
    </div>
    <dv-full-screen-container
      class="main-container"
      v-else
    >
      <div class="container">
        <div class="title-box">
          <div class="flex-box">
            <div class="left-box">安砂水力发电厂</div>
            <div class="center-box">水电机组发电水耗特性大数据在线分析与评价系统</div>
            <div class="right-box">
              <title-right></title-right>
            </div>
          </div>
        </div>
        <div class="model-box">
          <div class="box1">
            <div class="div1">
              <model-one ref="modelOneRef"></model-one>
            </div>
            <div class="div4">
              <model-four ref="modelFourRef"></model-four>
            </div>
          </div>
          <div class="box2">
            <div class="div2">
              <model-two ref="modelTwoRef"></model-two>
            </div>
            <div class="div5">
              <model-five ref="modelFiveRef"></model-five>
            </div>
          </div>
          <div class="box3">
            <div class="div3">
              <model-three ref="modelThreeRef"></model-three>
            </div>
            <div class="div6">
              <model-six ref="modelSixRef"></model-six>
            </div>
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import TitleRight from './components/TitleRight.vue'
import ModelOne from './components/ModelOne.vue'
import ModelTwo from './components/ModelTwo.vue'
import ModelThree from './components/ModelThree.vue'
import ModelFour from './components/ModelFour.vue'
import ModelFive from './components/ModelFive.vue'
import ModelSix from './components/ModelSix.vue'
import { api } from '@/api/api'
export default {
  name: 'App',
  components: {
    TitleRight,
    ModelOne,
    ModelTwo,
    ModelThree,
    ModelFour,
    ModelFive,
    ModelSix
  },
  data() {
    return {
      loading: true,
      timer: null,
      timer2: null,
    }
  },
  mounted() {
    let that = this
    setTimeout(() => {
      that.loading = false
      this.getData()
      this.setTimer()
      this.setTimer2()
    }, 2000)
  },
  beforeDestroy() {
    this.clearTimer()
    this.clearTimer2()
  },
  methods: {
    clearTimer() {
      clearInterval(this.timer)
      this.timer = null
    },
    clearTimer2() {
      clearInterval(this.timer2)
      this.timer2 = null
    },
    setTimer() {
      this.timer = setInterval(() => {
        this.$http.get({ url: api.realtimeList }).then(res => {
          res.data.list.forEach(v => {
            if (!v) v = []
          })
          let dataList = res.data.list
          this.$refs.modelFiveRef.setData(dataList)
        })
        this.$http.get({ url: api.unitHydraulicAnalysis }).then(res => {
          res.data.list.forEach(v => {
            if (!v) v = []
          })
          let dataList = res.data.list
          this.$refs.modelTwoRef.setData(dataList)
        })
        this.$refs.modelSixRef.getData()
      }, 2000)
    },
    getData() {
      this.$http.get({ url: api.realtimeList }).then(res => {
        res.data.list.forEach(v => {
          if (!v) v = []
        })
        let dataList = res.data.list
        // this.$refs.modelFourRef.setData(dataList)
        this.$refs.modelFiveRef.setData(dataList)
      })
      this.$http.get({ url: api.unitHydraulicComparison }).then(res => {
        res.data.list.forEach(v => {
          if (!v) v = []
        })
        let dataList = res.data.list
        this.$refs.modelFourRef.setData(dataList)
        // this.$refs.modelFiveRef.setData(dataList)
      })
      this.$http.get({ url: api.unitHydraulicAnalysis }).then(res => {
        try {
          res.data.list.forEach(v => {
            if (!v) v = []
          })
        } catch (error) {
          console.log(error)
        }
        let dataList = res.data.list
        this.$refs.modelTwoRef.setData(dataList)
      })
      this.$http.get({ url: api.unitTrendAnalysis }).then(res => {
        res.data.list.forEach(v => {
          if (!v) v = []
        })
        let dataList = res.data.list
        this.$refs.modelOneRef.setData(dataList)
      })
      // 获取配置
      this.$http.get({ url: api.getSetting }).then(res => {
        let data = res.data.data
        this.$refs.modelOneRef.setTitle(data)
        this.$refs.modelTwoRef.setTitle(data)
        this.$refs.modelThreeRef.setTitle(data)
        this.$refs.modelFourRef.setTitle(data)
      })
    },
    setTimer2() {
      this.timer2 = setInterval(() => {
        this.$http.get({ url: api.historyAnalysis }).then(res => {
          res.data.list.forEach(v => {
            if (!v) v = []
          })
          let dataList = res.data.list
          this.$refs.modelThreeRef.setData(dataList)
        })
        this.$http.get({ url: api.unitHydraulicComparison }).then(res => {
          res.data.list.forEach(v => {
            if (!v) v = []
          })
          let dataList = res.data.list
          this.$refs.modelFourRef.setData(dataList)
        })
      }, 3600000)
    },
  },
}
</script>

<style>
body {
  margin: 0 !important;
}
</style>

<style scoped lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #082041;
  margin: 0;
  height: 100vh;
}
.loading {
  width: 100%;
  height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-container {
  position: relative !important;
  overflow: auto !important;
  background-image: url('@/assets/img/mainBg.png');
  width: 100%;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  .container {
    width: 96%;
    height: 100%;
    padding: 0 2%;
    background-image: url('@/assets/img/bgFrame.png');
    background-size: 100% 100%;
    .title-box {
      width: 100%;
      height: 8%;
      margin-top: 10px;
      margin-bottom: 10px;

      .flex-box {
        position: relative;
        display: flex;
        align-items: center;
        color: #fff;
        height: 100%;
        background-image: url('@/assets/img/mainTitleBg.png');
        background-size: 100% 150%;
        .left-box {
          flex: 1;
          font-size: 22px;
          padding-left: 20px;
          text-align: left;
          padding-top: 20px;
        }
        .center-box {
          // flex: 1;
          text-align: center;
          font-size: 28px;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: 800;
          font-style: normal;
          background: linear-gradient(to bottom, #cfddf5 0%, #cfddf5 100%);
          // color: #ffffff;
          // background: radial-gradient(0deg, #cfddf5 0%, #cfddf5 100%);
          -webkit-background-clip: text; /*将设置的背景颜色限制在文字中*/
          // -webkit-text-fill-color: transparent; /*给文字设置成透明*/
          text-shadow: 4px 0px 0px rgba(0, 0, 0, 0.2);
        }
        .right-box {
          flex: 1;
          text-align: end;
          display: flex;
          justify-content: end;
          padding-right: 20px;
          padding-top: 25px;
        }
      }
    }

    .model-box {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 89%;
      .box1 {
        display: flex;
        flex-direction: column;
        width: 30%;
        height: 100%;
        .div1 {
          width: 100%;
          height: 65%;
          margin-bottom: 10px;
          background-image: url('@/assets/img/modelBg1.png');
          background-size: 100% 100%;
        }
        .div4 {
          width: 100%;
          height: 35%;
          background-image: url('@/assets/img/modelBg2.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
      .box2 {
        display: flex;
        flex-direction: column;
        width: 39%;
        height: 100%;
        .div2 {
          width: 100%;
          height: 70%;
          margin-bottom: 10px;
        }
        .div5 {
          width: 100%;
          height: 30%;
          background-image: url('@/assets/img/modelBg3.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
      .box3 {
        display: flex;
        flex-direction: column;
        width: 30%;
        height: 100%;
        .div3 {
          width: 100%;
          height: 65%;
          margin-bottom: 10px;
          background-image: url('@/assets/img/modelBg1.png');
          background-size: 100% 100%;
        }
        .div6 {
          width: 100%;
          height: 35%;
          background-image: url('@/assets/img/modelBg2.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
    }
  }
  // height: 100vh;
}
</style>
